export enum QueryKeys {
  StoreConfigurations = 'storeConfigurations',
  BankAccount = 'bankAccount',
}
